<form [formGroup]="skjema" (ngSubmit)="registrer()" [ngClass]="{'fullt-skjema':visFulltSkjema()}" class="e2e-ny-traad-skjema">
  <inline-skjema>
    <mat-form-field class="kommentar" appearance="outline">
      <mat-label>
        {{ 'Ny kommentartråd'|translate }}
      </mat-label>
      <textarea matInput
                [formControl]="skjema.controls.kommentar"
                (keydown.escape)="avbryt()"
                class="e2e-kommentarfelt"
                cdkTextareaAutosize
                tilpassAutosizeVedBreddeendring
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                data-testid="ny-kommentar-felt"
                #nyKommentarFelt></textarea>
      @if (skjema.controls.kommentar.hasError('maxlength')) {
        <mat-error data-testid="maxlength">{{ skjema.controls.kommentar.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
    </mat-form-field>

    @if (visFulltSkjema()) {

      @if (!skjema.value.privat) {
        <inline-melding type="info-transparent">{{ 'Alle kan se denne kommentaren'|translate }}</inline-melding>
        <mat-form-field class="varslede-medlemmer">
          <mat-label>{{ 'Velg hvem som skal varsles ({antall} valgt)'|translate:{antall: skjema.value.varsledeMedlemmer!.length} }}</mat-label>
          <velg-medlemmer [skjemakontroll]="skjema.controls.varsledeMedlemmer" [medlemmer]="medlemmer()" stil="kun-avatar"/>
        </mat-form-field>
      }

      <inline-skjema-handlinger navigasjonforhindret-flash>
          <button mat-raised-button color="primary" type="submit" [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()">
            {{ "Registrer" | translate }}
          </button>
          <button mat-raised-button (click)="avbryt()">
            {{ "Avbryt" | translate }}
          </button>
          <mat-slide-toggle [formControl]="skjema.controls.privat" matTooltip="{{'Private kommentarer er ikke synlige for andre enn deg'|translate}}">
            <i class="lederplan-ikon-eye-off-outline"></i>
            {{ "Privat" | translate }}
          </mat-slide-toggle>
      </inline-skjema-handlinger>
    }
  </inline-skjema>
</form>

